module.exports = __webpack_public_path__ + "media/img/pages/profile/csl ger 2-0a064426060cfed7c79af957c68a66f5.jpg";